import { render, staticRenderFns } from "./UiMsgBox.vue?vue&type=template&id=7aaaf4b2"
import script from "./UiMsgBox.vue?vue&type=script&lang=js"
export * from "./UiMsgBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7aaaf4b2')) {
      api.createRecord('7aaaf4b2', component.options)
    } else {
      api.reload('7aaaf4b2', component.options)
    }
    module.hot.accept("./UiMsgBox.vue?vue&type=template&id=7aaaf4b2", function () {
      api.rerender('7aaaf4b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui-msg-box/UiMsgBox.vue"
export default component.exports